export default __webpack_public_path__ + "64258757f44de43a3c9f5c7f5dedd3d8.png";